import type { JSX } from 'react';
import { DownOutlined } from '@ant-design/icons';
import i18n from '@app/i18n';
import { QuestionType } from '@data/sdk/match';
import { Button, AntdConfigProvider } from '@ui/components';
import {
  COLOR_BASE_900,
  COLOR_ERROR,
  COLOR_PRIMARY_500,
  COLOR_SECONDARY_200,
  COLOR_SECONDARY_500,
  COLOR_SUCCESS,
  COLOR_WARNING,
} from '@ui/constants';

export const getQuestionTypeButton = ({
  status,
  icon = true,
}: {
  icon?: boolean;
  status?: QuestionType;
}): JSX.Element | null => {
  switch (status) {
    case QuestionType.Standard:
      return (
        <AntdConfigProvider
          theme={{
            components: {
              Button: {
                defaultBg: `${COLOR_SUCCESS}19`,
                defaultBorderColor: `${COLOR_SUCCESS}50`,
                colorText: COLOR_BASE_900,
                defaultShadow: 'none',
              },
            },
          }}
        >
          <Button className="w-full hover:border-success/50 hover:text-base-900">
            {i18n.t('admin:question_type.standard')} {icon ? <DownOutlined /> : null}
          </Button>
        </AntdConfigProvider>
      );

    case QuestionType.TrialSpecific:
      return (
        <AntdConfigProvider
          theme={{
            components: {
              Button: {
                defaultBg: `${COLOR_PRIMARY_500}19`,
                defaultBorderColor: `${COLOR_PRIMARY_500}50`,
                colorText: COLOR_BASE_900,
                defaultShadow: 'none',
              },
            },
          }}
        >
          <Button className="w-full hover:border-primary-500/50 hover:text-base-900">
            {i18n.t('admin:question_type.trialSpecific')}
            {icon ? <DownOutlined /> : null}
          </Button>
        </AntdConfigProvider>
      );

    case QuestionType.Proposed:
      return (
        <AntdConfigProvider
          theme={{
            components: {
              Button: {
                defaultBg: COLOR_SECONDARY_200,
                defaultBorderColor: COLOR_SECONDARY_500,
                colorText: COLOR_BASE_900,
                defaultShadow: 'none',
              },
            },
          }}
        >
          <Button className="w-full hover:border-secondary-500 hover:text-base-900">
            {i18n.t('admin:question_type.proposed')} {icon ? <DownOutlined /> : null}
          </Button>
        </AntdConfigProvider>
      );
    case QuestionType.Physician:
      return (
        <AntdConfigProvider
          theme={{
            components: {
              Button: {
                defaultBg: `${COLOR_ERROR}19`,
                defaultBorderColor: `${COLOR_ERROR}50`,
                colorText: COLOR_BASE_900,
                defaultShadow: 'none',
              },
            },
          }}
        >
          <Button className="w-full hover:border-error/50 hover:text-base-900">
            {i18n.t('admin:question_type.physician')}
            {icon ? <DownOutlined /> : null}
          </Button>
        </AntdConfigProvider>
      );

    case QuestionType.Distractor:
      return (
        <AntdConfigProvider
          theme={{
            components: {
              Button: {
                defaultBg: `${COLOR_WARNING}19`,
                defaultBorderColor: `${COLOR_WARNING}50`,
                colorText: COLOR_BASE_900,
                defaultShadow: 'none',
              },
            },
          }}
        >
          <Button className="w-full hover:border-warning/50 hover:text-base-900">
            {i18n.t('admin:question_type.distractor')}
            {icon ? <DownOutlined /> : null}
          </Button>
        </AntdConfigProvider>
      );

    default:
      return null;
  }
};
